_ = require 'underscore'
pluginChromeTemplate = require 'views/templates/plugin_chrome'
pluginChromeHeaderTemplate = require 'views/templates/plugin_chrome_header'
pluginChromeWrapperTemplate = require 'views/templates/plugin_chrome_wrapper'
PluginView = require 'views/plugin/plugin-view'
Util = require 'lib/util'

class PluginChromeHeaderView extends PluginView

  initialize: ({ @pluginChromeView }) ->

  events: ->
    'click a[data-index].plugin-chrome-header-action': 'clickAction'

  clickAction: (e) ->
    index = parseInt(@$(e.currentTarget).attr('data-index'), 10)
    action = @pluginChromeView.content.actions[index]
    action?.callback?({ el: e.currentTarget })
    return

  render: ->
    @$el.html(pluginChromeHeaderTemplate(@pluginChromeView.content))
    @


module.exports = class PluginChromeView extends PluginView
  initialize: ({ @content }) ->
    @retain(@content)
    @stopResizing = @stopResizing.bind(@)

  events: ->
    'click .js-close-plugin-chrome': 'clickClose'
    'mousedown .js-resize-board-bar': 'initResize'

  clickClose: (e) ->
    @options.fxClose?()

  renderOnce: ->
    @headerView = @subview(PluginChromeHeaderView, @model, { pluginChromeView: @ })
    @$el.html(pluginChromeWrapperTemplate({ fullscreen: @content.fullscreen, resizable: @content.resizable }))
    @$wrapper = @$('.js-plugin-chrome-content')
    @appendSubview(@headerView, @$wrapper)
    @$wrapper.append(pluginChromeTemplate(@content))
    @initIFrames(@model)
    @

  update: (options) ->
    options = _.pick(options, 'actions', 'fullscreen', 'accentColor', 'title')
    _.extend(@content, options)
    if options.fullscreen
      @$wrapper.addClass('fullscreen')
    else if options.fullscreen == false
      @$wrapper.removeClass('fullscreen')
    if options.actions?
      @retain(@content.actions)
    @headerView.render()
    @

  close: ->
    @content.callback?()
    @isRemoved = true
    @remove()

  initResize: ->
    if !_.isFunction(@options.fxResize)
      return

    resize = (e) =>
      offset = @$('.js-resize-board-bar').offset().top
      delta = offset - e.clientY
      @options.fxResize?(delta)

    stopResizing = (e) =>
      window.removeEventListener('mousemove', resize)
      window.removeEventListener('mouseup', stopResizing)

    window.addEventListener('mousemove', resize)
    window.addEventListener('mouseup', stopResizing)




// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-chrome-view.coffee